import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Castle } from "lucide-react";

import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";
import { IconBadge } from "./IconBadge";

const TITLE = msg({
  id: "finding.costly_death",
  message: "{count, plural, one {# death} other {# deaths}} cost the team an objective",
});

const DETAILS = msg({
  id: "finding.costly_death.details",
  message: "While you were waiting to respawn, the team lost: {moments}.",
});

const MOMENT = msg({
  id: "finding.costly_death.moment",
  message: "{lost, select, building {a building} other {Mid Boss}} at {at} (you died at {time})",
});

const SUMMARY = msg({
  id: "finding.costly_death.summary",
  message: "{count} of your {total, plural, one {# death} other {# deaths}}",
});

// Пока игрок ждал возрождения, команда потеряла здание или Mid Boss.
export const CostlyDeath = ({ finding, variant }: FindingProps<"costly_death">) => {
  const { i18n } = useLingui();
  const { moments, total_deaths: total } = finding.params;
  const list = formatList(
    moments.map((moment) =>
      i18n._({
        ...MOMENT,
        values: {
          lost: moment.lost,
          at: formatGameTime(moment.lost_at_s),
          time: formatGameTime(moment.time_s),
        },
      }),
    ),
    i18n.locale,
  );
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<IconBadge icon={Castle} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: moments.length } })}
      details={i18n._({ ...DETAILS, values: { moments: list } })}
      summary={i18n._({ ...SUMMARY, values: { count: moments.length, total } })}
    />
  );
};
